import React from 'react';

const Analytics = React.lazy(() => import('./Analytics'));
const ActiveUser = React.lazy(() => import('./active-user'));
const CouponRedemptions = React.lazy(() => import('./coupon-redemptions'));
const Revenue = React.lazy(() => import('./revenue'));

export const analyticsRouteConfigs = [
  {
    path: '/analytics/dashboard',
    element: <Analytics />,
  },
  {
    path: '/analytics/revenue',
    element: <Revenue />,
  },
  {
    path: '/analytics/active-user',
    element: <ActiveUser />,
  },
  {
    path: '/analytics/coupon-redemptions',
    element: <CouponRedemptions />,
  },
];
